module.exports = __webpack_public_path__ + "files/84920682e554af90542918743f169b34.png";